module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.iframeLoad),
      expression: "iframeLoad"
    }],
    staticClass: "wrapper",
    on: {
      "click": function($event) {
        _vm.showList = false
      }
    }
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "topInput"
    }
  }), _vm._v(" "), _c('el-header', {
    attrs: {
      "background-color": "#409EFF",
      "fixed": "",
      "text-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "logo animation",
    class: {
      zoom: _vm.isShowMenu
    },
    style: (_vm.logoStyle)
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/erp_logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "user-count",
    on: {
      "click": _vm.getuserList
    }
  }, [_c('i', {
    staticClass: "iconfont theme-color"
  }, [_vm._v("")]), _c('span', {
    on: {
      "click": function($event) {
        _vm.isShowUserDialog = !_vm.isShowUserDialog
      }
    }
  }, [_vm._v(_vm._s(_vm.userList.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "right animation",
    class: {
      zoom: _vm.isShowMenu
    }
  }, [_c('ul', {
    staticClass: "top-menu",
    style: (_vm.headStyle)
  }, _vm._l((_vm.menuList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "top-menu-item",
      attrs: {
        "index": item.id
      },
      on: {
        "click": function($event) {
          return _vm.menuHandleSelect(item.id, [item.id + ''], '')
        },
        "mouseover": function($event) {
          return _vm.overMenu($event)
        },
        "mouseleave": function($event) {
          return _vm.leaveMenu($event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_vm._v("\n          " + _vm._s(_vm.userInfo ? _vm.userInfo.username : '') + "\n          "), _c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": require("../../assets/images/user.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.updatePassword($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add-dialog",
    attrs: {
      "title": "修改密码",
      "visible": _vm.uptPassVisible,
      "width": "534px"
    },
    on: {
      "update:visible": function($event) {
        _vm.uptPassVisible = $event
      },
      "close": function($event) {
        return _vm.uptPassClose()
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "原密码",
      "prop": "password_hash",
      "rules": [{
        required: true,
        message: '原密码不能为空',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "type": "password",
      "clearable": ""
    },
    model: {
      value: (_vm.passForm.password_hash),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "password_hash", $$v)
      },
      expression: "passForm.password_hash"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "新密码",
      "prop": "new_password_hash",
      "rules": [{
        required: true,
        message: '新密码不能为空',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "type": "password",
      "clearable": ""
    },
    model: {
      value: (_vm.passForm.new_password_hash),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "new_password_hash", $$v)
      },
      expression: "passForm.new_password_hash"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "确认新密码",
      "prop": "confirm_password_hash",
      "rules": [{
        required: true,
        message: '确认新密码不能为空',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "type": "password",
      "clearable": ""
    },
    model: {
      value: (_vm.passForm.confirm_password_hash),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "confirm_password_hash", $$v)
      },
      expression: "passForm.confirm_password_hash"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.uptPassCommit
    }
  }, [_vm._v("确 认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.uptPassClose
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-aside', {
    staticClass: "animation",
    class: {
      zoom: _vm.isShowMenu
    },
    style: ({
      backgroundColor: _vm.themeData.left_menu_bg_color
    }),
    attrs: {
      "width": "200px"
    }
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "native": false
    }
  }, [_c('div', {
    staticClass: "menu-top",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showList = true
      }
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": require("../../assets/images/user.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-r",
    style: ({
      color: _vm.themeData.left_menu_font_color
    })
  }, [_c('p', [_vm._v("欢迎.." + _vm._s(_vm.userInfo ? _vm.userInfo.position : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfo ? _vm.userInfo.username : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-box",
    style: ({
      backgroundColor: _vm.themeData.search_bg_color
    })
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "search-panel",
    style: ({
      color: _vm.themeData.search_font_color
    }),
    attrs: {
      "type": "text",
      "placeholder": "Quick Menu"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchMenu($event)
      },
      "focus": function($event) {
        _vm.showList = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.searchMenu
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList && _vm.searchKey),
      expression: "showList && searchKey"
    }],
    staticClass: "search-list"
  }, _vm._l((_vm.searchlist), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.showMenu(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.name) + "【" + _vm._s(item.parentData.name) + "】")])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "title",
    style: (_vm.mainNavStyle)
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), _c('el-menu', {
    ref: "menu2",
    staticClass: "sub-el-menu",
    attrs: {
      "defaultActive": _vm.activeIndex[1],
      "background-color": _vm.themeData.left_menu_bg_color,
      "text-color": _vm.themeData.left_menu_font_color,
      "active-text-color": _vm.themeData.left_menu_hover_color
    },
    on: {
      "select": _vm.activeItem
    }
  }, _vm._l((_vm.subMenuList), function(item) {
    return (item.children) ? _c('el-submenu', {
      key: item.id,
      attrs: {
        "index": item.id,
        "id": item.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(subItem) {
      return _c('el-menu-item-group', {
        key: subItem.key
      }, [(subItem.children) ? _c('el-submenu', {
        attrs: {
          "index": subItem.id,
          "id": subItem.id
        }
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(subItem.name))]), _vm._v(" "), _vm._l((subItem.children), function(i) {
        return _c('el-menu-item', {
          key: i.id,
          attrs: {
            "index": i.route,
            "id": i.id
          }
        }, [_vm._v(_vm._s(i.name))])
      })], 2) : _c('el-menu-item', {
        attrs: {
          "index": subItem.route,
          "id": subItem.id
        }
      }, [_vm._v("\n              " + _vm._s(subItem.name) + "\n            ")])], 1)
    })], 2) : _c('el-menu-item', {
      attrs: {
        "index": item.route,
        "id": "item.id"
      }
    }, [_c('i', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])])
  }), 1)], 1), _vm._v(" "), _c('a', {
    staticClass: "zoom-menu",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.isShowMenu = !_vm.isShowMenu
      }
    }
  }, [_c('img', {
    staticClass: "animation",
    class: {
      zoom: _vm.isShowMenu
    },
    attrs: {
      "src": require("../../assets/images/zoom.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-main', {
    staticClass: "animation",
    class: {
      zoom: _vm.isShowMenu
    }
  }, [_c('section', {
    staticClass: "nav-tags-box animation",
    class: {
      zoom: _vm.isShowMenu
    }
  }, [_c('div', {
    staticClass: "nav-tags"
  }, [_c('div', {
    staticClass: "tags-view-wrapper test-5"
  }, [_c('span', {
    ref: "tag",
    staticClass: "el-tag el-tag--mini",
    on: {
      "click": function($event) {
        _vm.currentId = 0
      }
    }
  }, [_c('i', {
    staticClass: "circle",
    class: _vm.currentId === 0 ? 'active' : ''
  }), _vm._v("\n              首页\n            ")]), _vm._v(" "), _vm._l((_vm.tags), function(tag, index) {
    return _c('span', {
      key: index,
      ref: "tag",
      refInFor: true,
      staticClass: "el-tag el-tag--mini",
      on: {
        "click": function($event) {
          return _vm.toTargetUrl(tag)
        }
      }
    }, [_c('i', {
      staticClass: "circle",
      class: {
        active: tag.id == _vm.currentId
      }
    }), _vm._v("\n              " + _vm._s(tag.name) + "\n              "), _c('i', {
      staticClass: "el-tag__close el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeHandle(index, tag.id)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "right-dropdown"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("\n                标签选项\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "all"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "other"
    }
  }, [_vm._v("其他标签")])], 1)], 1)], 1)])]), _vm._v(" "), (_vm.currentId == 0 || _vm.currentId == '') ? _c('div') : _vm._e(), _vm._v(" "), _c('home', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentId === 0),
      expression: "currentId === 0"
    }]
  }), _vm._v(" "), _vm._l((_vm.onloadTags), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentId == item.id),
        expression: "currentId == item.id"
      }],
      attrs: {
        "id": item.id,
        "currentId": _vm.currentId
      }
    }, [_c('iframe', {
      staticStyle: {
        "width": "100%"
      },
      style: ({
        height: _vm.iframeHeight + 'px'
      }),
      attrs: {
        "frameborder": "0",
        "allowfullscreen": "",
        "src": '/#' + item.router,
        "name": 'iframe' + item.id
      },
      on: {
        "load": function($event) {
          return _vm.iframeOnload(item.id, index)
        }
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.unloadTags), function(item, index) {
    return _c('div', {
      key: item.key
    }, [(_vm.currentId == item.id) ? _c('div', {
      attrs: {
        "id": item.id,
        "currentId": _vm.currentId
      }
    }, [_c('iframe', {
      staticStyle: {
        "width": "100%"
      },
      style: ({
        height: _vm.iframeHeight + 'px'
      }),
      attrs: {
        "frameborder": "0",
        "allowfullscreen": "",
        "src": '/#' + item.router,
        "name": 'iframe' + item.id
      },
      on: {
        "load": function($event) {
          return _vm.iframeOnload(item.id, index)
        }
      }
    })]) : _vm._e()])
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "width": "30%",
      "min-height": "200"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('table', {
    staticClass: "user-list"
  }, [_c('tr', [_c('th', [_vm._v("用户名")]), _vm._v(" "), _c('th', [_vm._v("首次登录时间")]), _vm._v(" "), _c('th', [_vm._v("最后操作时间")])]), _vm._v(" "), _vm._l((_vm.userList), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.last_time))])])
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3206920","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = 0KdX
// module chunks = 511